import { createContext } from 'react';
const GlobalContext = createContext({
    userDetails: { name: '', mobile_number: '' },
});

export default GlobalContext;
